import React, { createContext, useState, useEffect } from 'react';

const SessionContext = createContext();

const initialUser = {};
const initialMenu = {};
const initialRecuperar = false;

const getLocalValue = (key, fallback) => {
    try {
        const stored = localStorage.getItem(key);
        return stored ? JSON.parse(stored) : fallback;
    } catch {
        return fallback;
    }
};

const SessionProvider = ({ children }) => {
    const [user, setUser] = useState(() => getLocalValue('user', initialUser));
    const [menu, setMenu] = useState(() => getLocalValue('menu', initialMenu));
    const [recuperar, setRecuperar] = useState(() => getLocalValue('recuperar', initialRecuperar));

    const login = (userData) => setUser({ ...user, ...userData });
    const logout = () => {
        localStorage.removeItem('user');
        localStorage.removeItem('accessToken');
        setUser(initialUser);
    };

    const marcarMenu = (menu) => setMenu(menu);
    const desmarcarMenu = () => {
        localStorage.removeItem('menu');
        setMenu(initialMenu);
    };

    const recuperarPass = () => setRecuperar(true);
    const mostrarLogin = () => {
        localStorage.removeItem('recuperar');
        setRecuperar(false);
    };

    useEffect(() => {
        if (Object.keys(user).length > 0) {
            localStorage.setItem('user', JSON.stringify(user));
        }
    }, [user]);

    useEffect(() => {
        localStorage.setItem('menu', JSON.stringify(menu));
    }, [menu]);

    useEffect(() => {
        localStorage.setItem('recuperar', JSON.stringify(recuperar));
    }, [recuperar]);

    const values = {
        user, setUser, login, logout,
        menu, marcarMenu, desmarcarMenu,
        recuperar, recuperarPass, mostrarLogin
    };

    return (
        <SessionContext.Provider value={values}>
            {children}
        </SessionContext.Provider>
    );
};

export default SessionContext;
export { SessionProvider };
